import { createFileRoute } from "@tanstack/react-router";

import { ProfilePage } from "@/auth/ProfilePage";
import { pageTitle } from "@/i18n/title";

export const Route = createFileRoute("/_authed/profile")({
  head: () => pageTitle("Profile"),
  component: ProfilePage,
});
